module.exports = function() {
  return new Worker(__webpack_public_path__ + "e567815e0f4988be7130.worker.js");
};